import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { Popconfirm, type TableColumnsType } from 'antd';
import type { Key, SortOrder } from 'antd/lib/table/interface';
import { Button, EmptyCell } from 'components';
import { Link } from 'react-router-dom';
import { commoditiesConfig } from '@/utils/commodities';
import { Icon } from '@/components/icon';

export const getMeterModelsColumnsConfig = ({
  loading,
  isMagicRole,
  onDelete,
  sortState,
}: {
  loading: boolean;
  isMagicRole: boolean;
  onDelete: (modelId: SerializedMeterModel['id']) => void;
  sortState: { field: Key | null; order: SortOrder };
}): TableColumnsType<SerializedMeterModel> => [
  {
    key: 'commodity',
    title: 'Commodity',
    width: 50,
    render: (_, record) => {
      const iconString = commoditiesConfig[record.commodity]?.iconString;
      return iconString ? <Icon iconString={iconString} /> : <EmptyCell />;
    },
  },
  {
    key: 'name',
    title: 'Name',
    width: 200,
    sorter: true,
    sortOrder: sortState.field === 'name' ? sortState.order : null,
    render: (_, record) => (
      <Link to={{ pathname: `/reseller-data/model-library/model/${record.id}` }}>{record.name}</Link>
    ),
  },
  {
    key: 'manufacturer',
    title: 'Manufacturer',
    width: 200,
    render: (_, record) => <>{record.manufacturer?.name ?? <EmptyCell />}</>,
  },
  ...(isMagicRole
    ? ([
        {
          key: 'action',
          width: 50,
          title: 'Actions',
          fixed: 'right',
          render: (_, record) => (
            <Popconfirm
              cancelText="Cancel"
              okText="Confirm"
              okType="danger"
              title="Do you want to delete this item? This action is irreversible."
              zIndex={99999}
              onConfirm={() => onDelete(record.id)}
            >
              <Button danger disabled={!onDelete} icon={<Icon iconString="delete" />} loading={loading} type="text" />
            </Popconfirm>
          ),
        },
      ] satisfies TableColumnsType<SerializedMeterModel>)
    : []),
];
